import { defineComponent as _defineComponent } from 'vue'
import { AudioTechnology, PresentationType, VideoTechnology } from '@/@types/graphql-types';
import { TitleOfferFragment } from '@/components/buybox/graphql/fragments/Offer.fragment';
import { useI18n } from '@/helpers/composables/useI18n';
import { getTranslatableForShowOfferGraphql } from '@/helpers/offer-helper';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { useExperiment } from '@/libraries/experiment';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyBoxOfferNewPresentation',
  props: {
    offer: null,
    title: null
  },
  setup(__props: any) {

const props = __props as {
	offer: TitleOfferFragment & {
		bundleId?: number;
		bundleClearName?: string;
		bundleTechnicalName?: string;
		icons?: { iconWide: string; packageId: number }[];
		availableFromTime?: string;
		offerSeasons?: string[];
		minRetailPrice?: string;
	};
	title: TitleDetail;
};

const BuyBoxInfoModal = () => import('@/components/buybox-new/BuyBoxInfoModal.vue');



const { tc } = useI18n();

const displayBuyBoxInfoModal = ref<boolean>(false);

const buyboxOffer = computed(() => {
	return props.offer;
});

// OVER_PROVIDER_EXP_V2
const { activeVariant: overProviderExpVariant } = useExperiment('OVER_PROVIDER_EXP_V2');
// OVER_PROVIDER_EXP_V2

const audioLanguages = computed(() => {
	if (!buyboxOffer.value?.audioLanguages) return false;
	return languageArrayToString(props?.offer?.audioLanguages);
});

const presentationTypeLabel = computed(() => {
	switch (buyboxOffer.value?.presentationType) {
		case PresentationType.Hd:
			return 'HD';
		case PresentationType['4K']:
			return '4K';
		case PresentationType.Dvd:
			return 'DVD';
		case PresentationType.Bluray:
			return 'Blu-Ray';
		default:
			return '';
	}
});

const ageRating = computed(() => {
	if (props.title.__typename !== 'Season') {
		return props.title.content.ageCertification;
	}
	return null;
});

const dolbyTechnology = computed(() => {
	return (
		buyboxOffer.value?.videoTechnology.includes(VideoTechnology.DolbyVision) ||
		buyboxOffer.value?.audioTechnology.includes(AudioTechnology.Dolby_5Point_1) ||
		buyboxOffer.value?.audioTechnology.includes(AudioTechnology.DolbyAtmos)
	);
});

const showText = computed(() => getTranslatableForShowOfferGraphql(buyboxOffer.value, props.title.objectType));

const runtimeMins = computed(() => (props.title?.content?.runtime ? `${props.title.content.runtime}min` : null));

function languageArrayToString(languageArray: string[]) {
	const languages = languageArray.map(language => {
		return {
			language,
			name: tc(`WEBAPP_LANGUAGE_${language.toUpperCase()}`),
		};
	});
	const filteredLanguages = languages.filter((language: { language: string; name: string }) => {
		return !language.name.startsWith('WEBAPP_LANGUAGE_');
	});
	return filteredLanguages
		.map((language: { language: string; name: string }) => {
			return language.name;
		})
		.join(', ');
}

function toggleBuyBoxInfoModal(display: boolean) {
	displayBuyBoxInfoModal.value = display;

	if (displayBuyBoxInfoModal.value) {
		TrackingHelper.trackEvent('userinteraction', { action: 'more_info_clicked', label: 'buybox' });
	}
}

return { __sfc: true,BuyBoxInfoModal, props, tc, displayBuyBoxInfoModal, buyboxOffer, overProviderExpVariant, audioLanguages, presentationTypeLabel, ageRating, dolbyTechnology, showText, runtimeMins, languageArrayToString, toggleBuyBoxInfoModal }
}

})